import React, { memo, useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import icon_info_dialog_red from "assets/icon_info_dialog_red.svg";
import { useTranslation } from "react-i18next";
import ServiceBase from "utils/ServiceBase";
import ModalLoading from "components/modal/Loading";
import { toast } from "react-toastify";
import icon_cancel_dialog from "assets/icon_cancel_dialog.png";
import {
  setOpenNoInternetModal,
  pushApiErrorData,
  setApiErrorOpen,
} from "redux/action";
import { checkNetworkConnection } from "utils/ServiceBase";
import { useDispatch } from "react-redux";
import { notification } from "antd";

const ModalTermAndCondition = memo(({ className, onCancel, isOpen }) => {
  const { t } = useTranslation("translation");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    termAndCondition();
  }, []);

  const handleCheckNetworkConnect = () => {
    if (checkNetworkConnection()) return true;
    else {
      dispatch(setOpenNoInternetModal(true));
      return false;
    }
  };

  const termAndCondition = useCallback(async () => {
    if (!handleCheckNetworkConnect()) return;
    setLoading(true);
    const response = await ServiceBase.requestJson({
      method: "GET",
      url: `/ggg/api/v2.0/tgs-connect/termAndCondition`,
      data: {},
    });
    console.log(response);
    if (response?.value?.code === "200") {
      if (response?.value?.data) {
        setData(response?.value?.data);
        setLoading(false);
      } else {
        toast.error(
          response?.value?.mess ||
            response?.value?.message ||
            response?.message ||
            t("error")
        );
        setLoading(false);
      }
    } else {
      if (response?.code === "ECONNABORTED") {
        const url = `/ggg/api/v2.0/tgs-connect/termAndCondition`;
        handlePushApiError({ url, time: Date.now() });
        notification["error"]({
          key: "internalServerError",
          message: t("internalServerError"),
          duration: 15,
          description: (
            <span style={{ color: "#2083DA" }} onClick={handleShowApiErrors}>
              {t("forDev")}
            </span>
          ),
        });
      } else {
        toast.error(
          response?.value?.mess ||
            response?.value?.message ||
            response?.message ||
            t("error")
        );
      }
      setLoading(false);
    }
  });

  const handlePushApiError = (api) => {
    dispatch(pushApiErrorData([api]));
  };

  const handleShowApiErrors = () => {
    notification.close("gpos-key");
    dispatch(setApiErrorOpen(true));
  };

  return (
    <div className={className}>
      {loading && <ModalLoading />}
      <div className=" relative view_content mt-16 bg-white">
        <div>
          <div className="flex ml-4 mr-4 terms-content-wrap mt-1">
            <div
              dangerouslySetInnerHTML={{
                __html: data?.["description"],
              }}
              className="terms-html-content"
            ></div>
          </div>
        </div>
      </div>

      <div className="relative header w-full bg-white">
        <div
          onClick={onCancel}
          className="icon_cancel absolute left-0 top-0 mt-4 ml-4"
        >
          <img src={icon_cancel_dialog} />
        </div>
        <div className=" textTitle justify-center items-center flex mt-4 pb-3">
          {t("termAndCondition")}
        </div>
      </div>
    </div>
  );
});

export default styled(ModalTermAndCondition)`
  .header {
    top: 0;
    position: fixed;
  }
  .textTitle {
    line-height: 26px;
    color: #1a1a1a;
    font-size: 18px;
    font-weight: 700;
    font-family: "Manrope-Medium", sans-serif;
  }

  .terms-content-wrap {
    width: calc(100% - 32px);
  }

  .terms-html-content,
  .terms-html-content * {
    color: #4d4d4d !important;
    font-family: "Manrope-Medium", sans-serif !important;
    font-size: 15px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 22px !important;
  }

  .terms-html-content h1,
  .terms-html-content h2,
  .terms-html-content h1 *,
  .terms-html-content h2 * {
    color: #1a1a1a !important;
    font-family: "Manrope-Bold", sans-serif !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    line-height: 26px !important;
  }

  .terms-html-content h3,
  .terms-html-content h4,
  .terms-html-content h5,
  .terms-html-content h6,
  .terms-html-content h3 *,
  .terms-html-content h4 *,
  .terms-html-content h5 *,
  .terms-html-content h6 *,
  .terms-html-content strong,
  .terms-html-content b {
    color: #1a1a1a !important;
    font-family: "Manrope-Bold", sans-serif !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    line-height: 22px !important;
  }

  .terms-html-content a,
  .terms-html-content a * {
    color: #2083da !important;
  }

  .terms-html-content p,
  .terms-html-content ul,
  .terms-html-content ol {
    margin: 0 0 12px !important;
  }
  .btn {
    width: 190px;
    height: 50px;
    border-radius: 6px;
    background: #1a1a1a;
  }
  .text_yes {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    font-family: "Manrope", sans-serif;
  }
`;
